module.exports = fox._r("images/sprite-small-preloader-white.png", __webpack_public_path__ + "images/sprite-small-preloader-white.png");


//////////////////
// WEBPACK FOOTER
// ./images/sprite-small-preloader-white.png
// module id = 148
// module chunks = 5